import { TransactionsComponent } from './views/admin/transactions/transactions.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// Import Containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import {LoginComponent} from './views/auth/login/login.component';
import {RegisterComponent} from './views/auth/register/register.component';
import {ForgetPasswordComponent} from './views/auth/forget-password/forget-password.component';
import {AuthGuard} from '../services/auth.guard';
import {UserComponent} from "./views/admin/user/user.component";
import {CommerciauxComponent} from "./views/admin/commerciaux/commerciaux.component";
import {CommercialComponent} from "./views/admin/commercial/commercial.component";
import {SellerComponent} from "./views/admin/seller/seller.component";
import {ReversementEncoursComponent} from "./views/admin/reversement-encours/reversement-encours.component";
import {ReversementEffectuesComponent} from "./views/admin/reversement-effectues/reversement-effectues.component";
import {CommissionComponent} from "./views/admin/commission/commission.component";
import {SellerReversementsComponent} from "./views/admin/seller-reversements/seller-reversements.component";
import {UserDetailsComponent} from "./views/admin/user-details/user-details.component";
import {NewletterComponent} from "./views/admin/newletter/newletter.component";
import {CommandeComponent} from "./views/admin/commande/commande.component";
import {GiftcardComponent} from "./views/admin/giftcard/giftcard.component";
import { CategorieComponent } from './views/admin/categorie/categorie.component';
import { ArticleComponent } from './views/admin/article/article.component';
import { PhotosComponent } from './views/admin/article/photos/photos.component';
import {AuditComponent} from "./views/admin/audit/audit.component";
import {OrangeComponent} from "./views/admin/orange/orange.component";
import {KahpooComponent} from "./views/admin/kahpoo/kahpoo.component";
import { FaqComponent } from './views/admin/faq/faq.component';
import { ParrainageComponent } from './views/admin/parrainage/parrainage.component';
import { FilleuleComponent } from './views/admin/filleule/filleule.component';
import { SponsorshipDetailsComponent } from './views/admin/sponsorship-details/sponsorship-details.component';
import { CountryComponent } from './views/admin/localisations/country/country.component';
import { CityComponent } from './views/admin/localisations/city/city.component';
import { DistrictComponent } from './views/admin/localisations/district/district.component';
import { StreetComponent } from './views/admin/localisations/street/street.component';
import { ZoneComponent } from './views/admin/localisations/zone/zone.component';
import { TripeExpenseComponent } from './views/admin/localisations/tripe-expense/tripe-expense.component';
import { NotesComponent } from './views/admin/notes/notes.component';
import {PublicationsComponent} from "./views/admin/publications/publications.component";
import { ReplyMessageComponent } from './views/admin/reply-message/reply-message.component';
import { ChatNotificationComponent } from './views/admin/chat-notification/chat-notification.component';
import { KahpooShopComponent } from './views/admin/kahpoo-shop/kahpoo-shop.component';
import {MailComponent} from "./views/admin/mail/mail.component";
import { CommercialClientsComponent } from './views/admin/commercial-clients/commercial-clients.component';
import {OrderItemComponent} from "./views/admin/order-item/order-item.component";
import { CharacteristicsComponent } from './views/admin/shop/characteristics/characteristics.component';
import { CategorieShopComponent } from './views/admin/shop/categorie-shop/categorie-shop.component';
import { UpdateSubCategoryComponent } from './views/admin/sub-category/update-sub-category/update-sub-category.component';
import { DomainComponent } from './views/admin/domain/domain.component';
import {SubCategoryComponent} from './views/admin/sub-category/sub-category.component';
import { PublicationsComponent2 } from './views/admin/publications2/publications2.component';
import {GiftcardPublishedComponent} from './views/admin/kahpoo-shop/giftcard-published/giftcard-published.component';
import { PromotionComponent } from './views/admin/kahpoo-shop/promotion/promotion.component';
import { PromotionOfferComponent } from './views/admin/kahpoo-shop/promotion-offer/promotion-offer.component';
import { OfferTypeComponent } from './views/admin/kahpoo-shop/offer-type/offer-type.component';
import { PromotionOfferActiveComponent } from './views/admin/kahpoo-shop/promotion-offer-active/promotion-offer-active.component';
import { ReservationComponent } from './views/admin/reservation/reservation.component';
import { PostPromoteComponent } from './views/admin/kahpoo-shop/post-promote/post-promote.component';
import { PassComponent } from './views/admin/kahpoo-shop/pass/pass.component';
import { PassPublishedComponent } from './views/admin/kahpoo-shop/pass/pass-published/pass-published.component';
import { ListPassUserComponent } from './views/admin/kahpoo-shop/pass/list-pass-user/list-pass-user.component';
import { ListShopComponent } from './views/admin/shop/list-shop/list-shop.component';
import { ListProductComponent } from './views/admin/shop/list-shop/list-product/list-product.component';
import { ListServiceComponent } from './views/admin/shop/list-shop/list-service/list-service.component';
import { EmployeOfferComponent } from './views/admin/kahpoo-shop/employe-offer/employe-offer.component';
import { AppliedUserComponent } from './views/admin/kahpoo-shop/employe-offer/applied-user/applied-user.component';
import { EmployeOfferPublishedComponent } from './views/admin/kahpoo-shop/employe-offer/employe-offer-published/employe-offer-published.component';
import { KahpooEmployeOfferComponent } from './views/admin/kahpoo-shop/employe-offer/kahpoo-employe-offer/kahpoo-employe-offer.component';
import { VarianteComponent } from './views/admin/shop/list-shop/list-product/variante/variante.component';
import { AllPromotionsOfferActiveComponent } from './views/admin/kahpoo-shop/all-promotions-offer-active/all-promotions-offer-active.component';
import { PrivateSpaceComponent } from './views/admin/espace-prive/private-space/private-space.component';
import { CustomerSpaceComponent } from './views/admin/espace-prive/customer-space/customer-space.component';
import { PostPrivateSpaceComponent } from './views/admin/espace-prive/post-private-space/post-private-space.component';
import { VariantPrivateSpaceComponent } from './views/admin/espace-prive/variant-private-space/variant-private-space.component';
import { UsersWithSoldProductsComponent } from './views/admin/users-with-sold-products/users-with-sold-products.component';
import { UsersWithSoldProductsDetailsComponent } from './views/admin/users-with-sold-products-details/users-with-sold-products-details.component';
import { UserNewVersionComponent } from './views/admin/user-new-version/user-new-version.component';
import { title } from 'process';
import { DelegationComponent } from './views/admin/delegation/delegation.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page'
    }
  },
  {
    path: 'forget-password',
    component: ForgetPasswordComponent,
    data: {
      title: 'Mot de pass oublié'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [ AuthGuard ],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'sellers',
        component: SellerComponent,
        data: {
          title: 'Utilisateurs vendeurs'
        }
      },
      {
        path: 'kahpoo-sellers',
        component: UserNewVersionComponent,
        data: {
          title: 'Utilisateurs vendeurs'
        }
      },
      {
        path: 'seller-reversements/:id',
        component: SellerReversementsComponent,
        data: {
          title: 'Reversements du vendeur'
        }
      },
      {
        path: 'reversement-encours',
        component: ReversementEncoursComponent,
        data: {
          title: 'Reversement en cours'
        }
      },
      {
        path: 'reversement-effectues',
        component: ReversementEffectuesComponent,
        data: {
          title: 'Reversement effectués'
        }
      },
      {
        path: 'commisions',
        component: CommissionComponent,
        data: {
          title: 'Commisions'
        }
      },
      {
        path: 'commerciaux',
        component: CommerciauxComponent,
        data: {
          title: 'Commerciaux'
        }
      },
      {
        path: 'enroles',
        component: CommercialComponent,
        data: {
          title: 'Utilisateurs enrolés par les commerciaux'
        }
      },
      {
        path: 'users-with-sold-products',
        component: UsersWithSoldProductsComponent,
        data: {
          title: 'Vendeur(s) ayant au moins une vente'
        }
      },
      {
        path: 'users-with-sold-products-details/:id',
        component: UsersWithSoldProductsDetailsComponent,
        data: {
          title: 'Détail utilisateur'
        }
      },
      {
        path: 'users',
        component: UserComponent,
        data: {
          title: 'Utilisateurs enrolés par les commerciaux'
        }
      },
      {
        path: 'user-details/:id',
        component: UserDetailsComponent,
        data: {
          title: 'Détail utilisateur'
        }
      },
      {
        path: 'newletter',
        component: NewletterComponent,
        data: {
          title: 'Newsletters'
        }
      },
      {
        path: 'users',
        component: UserComponent,
        data: {
          title: 'Utilisateurs enrolés par les commerciaux'
        }
      },
      {
        path: 'user-details/:id',
        component: UserDetailsComponent,
        data: {
          title: 'Détail utilisateur'
        }
      },
      {
        path: 'newletter',
        component: NewletterComponent,
        data: {
          title: 'Newsletters'
        }
      },
      {
        path: 'commande',
        component: CommandeComponent,
        data: {
          title: 'Commande'
        }
      },
      {
        path: 'orange',
        component: OrangeComponent,
        data: {
          title: 'API Orange'
        }
      },
      {
        path: 'kahpoo',
        component: KahpooComponent,
        data: {
          title: 'Wallet Kahpoo'
        }
      },
      {
        path: 'giftcard',
        component: GiftcardComponent,
        data: {
          title: 'Carte cadeaux'
        }
      },
      {
        path: 'transactions',
        component: TransactionsComponent,
        data: {
          title: 'Transactions'
        }
      },
      {
        path: 'images',
        component: PhotosComponent,
        data: {
          title: 'Images des posts'
        }
      },
      {
        path: 'categorie',
        component: CategorieComponent,
        data: {
          title: 'Catégorie post'
        }
      },
      {
        path: 'article',
        component: ArticleComponent,
        data: {
          title: 'Article'
        }
      },
      {
        path: 'audit',
        component: AuditComponent,
        data: {
          title: 'Audit'
        }
      },
      {
        path: 'orderitem',
        component: OrderItemComponent,
        data: {
          title: 'Commande'
        }
      },
      {
        path: 'parrainage',
        component: ParrainageComponent,
        data: {
          title: 'Parrainage'
        }
      },
      {
        path: 'private-space',
        component: PrivateSpaceComponent,
        data: {
          title: 'Espace Privé'
        }
      },
      {
        path: 'filleule',
        component: FilleuleComponent,
        data: {
          title: 'Filleule'
        }
      },
      {
        path: 'faq',
        component: FaqComponent,
        data: {
          title: 'Faq'
        }
      },
      {
        path: 'sponsorship-details/:id',
        component: SponsorshipDetailsComponent,
        data: {
          title: 'Détail du parrain'
        }
      },

      {
        path: 'customer/private_space/:id',
        component: CustomerSpaceComponent,
        data: {
          title: 'Utilisateurs associés à l\'espace'
        }
      },
      {
        path: 'variant/private_space/:id',
        component: VariantPrivateSpaceComponent,
        data: {
          title: 'Annoces associées à l\'espace'
        }
      },
      {
        path: 'country',
        component: CountryComponent,
        data: {
          title: 'Country'
        }
      },
      {
        path: 'city',
        component: CityComponent,
        data: {
          title: 'City'
        }
      },
      {
        path: 'district',
        component: DistrictComponent,
        data: {
          title: 'District'
        }
      },
      {
        path: 'street',
        component: StreetComponent,
        data: {
          title: 'Street'
        }
      },
      {
        path: 'zone',
        component: ZoneComponent,
        data: {
          title: 'Zone'
        }
      },
      {
        path: 'tripExpense',
        component: TripeExpenseComponent,
        data: {
          title: 'TripeExpense'
        }
      },
      {
        path: 'mail',
        component: MailComponent,
        data: {
          title: 'Mail'
        }
      },
      {
        path: 'zone',
        component: ZoneComponent,
        data: {
          title: 'Zone'
        }
      },
      {
        path: 'notes',
        component: NotesComponent,
        data: {
          title: 'Notes'
        }
      },
      {
        path: 'replyMessage',
        component: ReplyMessageComponent,
        data: {
          title: 'Réponse Message'
        }
      },
      {
        path: 'boutiques',
        component: ListShopComponent,
        data: {
          title: 'Boutiques'
        }
      },
      {
        path: 'list-product/:id',
        component: ListProductComponent,
        data: {
          title: 'Liste des produits'
        }
      },
      {
        path: 'list-service/:id',
        component: ListServiceComponent,
        data: {
          title: 'Liste des services'
        }
      },
      {
        path: 'publications',
        component: PublicationsComponent2,
        data: {
          title: 'Publications'
        }
      },
      {
        path: 'categorie-shop',
        component: CategorieShopComponent,
        data: {
          title: 'Categorie Shop'
        }
      },
      {
        path: 'update-sub-category/:id',
        component: UpdateSubCategoryComponent,
        data:{
          title: 'Update Sub-category'
        }
      },
      {
        path: 'utilisateurs-gestionnaires',
        component: DelegationComponent,
        data: {
          title: 'Utilisateurs gestionnaires'
        }
      },
      {
        path: 'characteristics',
        component: CharacteristicsComponent,
        data: {
          title: 'Characteristics'
        }
      },
      {
        path: 'sous-categorie',
        component: SubCategoryComponent,
        data: {
          title: 'Sous-catégorie'
        }
      },
      {
        path: 'categorie',
        component: CategorieShopComponent,
        data: {
          title: 'Categorie'
        }
      },
      {
        path: 'kahpooShop',
        component: KahpooShopComponent,
        data: {
          title: 'Boutique Kahpoo'
        }
      },
      {
        path: 'pass',
        component: PassComponent,
        data: {
          title: 'PASS'
        }
      },
      {
        path: 'liste_subscribe',
        component: ListPassUserComponent,
        data: {
          title: 'subscribe'
        }
      },
      {
        path: 'giftcard-published/:shopID',
        component: GiftcardPublishedComponent,
        data: {
          title: 'Cartes cadeaux publiées'
        }
      },
      {
        path: 'pass-published/:shopID',
        component: PassPublishedComponent,
        data: {
          title: 'Forfait abonnements publiées'
        }
      },
      {
        path: 'commercial-clients/:id',
        component: CommercialClientsComponent,
        data: {
          title: 'Utilisateur enrôlés par le commercial'
        }
      },
      {
        path: 'domain',
        component: DomainComponent,
        data: {
          title: 'domain'
        }
      },
      {
        path: 'promotion',
        component: PromotionComponent,
        data: {
          title: 'promotion'
        }
      },
      {
        path: 'all-promotions-offer-active',
        component: AllPromotionsOfferActiveComponent,
        data: {
          title: 'all-promotions-offer-active'
        }
      },
      {
        path: 'promotion-offer-active',
        component: PromotionOfferActiveComponent,
        data: {
          title: 'promotion-offer-active'
        }
      },
      {
        path: 'promote',
        component: PostPromoteComponent,
        data: {
          title: 'promote'
        }
      },

      {
        path: 'promotion-offer',
        component: PromotionOfferComponent,
        data: {
          title: 'promotion-offer'
        }
      },
      {
        path: 'offer-type',
        component: OfferTypeComponent,
        data: {
          title: 'offer-type'
        }
      },
      {
        path: 'reservation',
        component: ReservationComponent,
        data: {
          title: 'reservation'
        }
      },
      {
        path: 'employe-offer',
        component: EmployeOfferComponent,
        data: {
          title: 'employe-offer'
        }
      },
      {
        path: 'applied-user/:id',
        component: AppliedUserComponent,
        data: {
          title: 'applied-user'
        }
      },
      {
        path: 'employe-offer-published',
        component: EmployeOfferPublishedComponent,
        data: {
          title: 'employe-offer-published'
        }
      },
      {
        path: 'kahpoo-employe-offer',
        component: KahpooEmployeOfferComponent,
        data: {
          title: 'kahpoo-employe-offer'
        }
      },
      {
        path: 'variante/:id',
        component: VarianteComponent,
        data: {
          title: 'Liste des variantes'
        }
      }

    ]
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
